import { useContext } from 'react'
import { ICampaignFilterContext } from '../interfaces'
import { CampaignFilterContext } from '../context/CampaignFilter.context'

export const useCampaignFilterContext = (): ICampaignFilterContext => {
   const context = useContext(CampaignFilterContext)

   if (context === undefined) {
      throw new Error(
         'useCampaignFilterContext must be used within a CampaignFilterProvider'
      )
   }

   return context
}
